var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative flex justify-center w-full py-6 bg-slate-200",
      attrs: { id: "cumulative-graph" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-full max-w-5xl border bg-pure-white rounded-3xl border-slate-400"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col gap-8 p-6 border-b lg:p-10 border-slate-400",
              attrs: { id: "graph-display" }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-col gap-1" },
                [
                  _c("BlTextTitle4", { attrs: { text: "Cumulative Graph" } }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "With the cumulative graph, you can easily track the progress of the mastered targets over time."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-4" },
                [
                  _c("BlInputFilter", {
                    staticClass: "w-40",
                    attrs: { input: _vm.filterInput },
                    on: { changed: _vm.onChangeDate }
                  }),
                  _vm._v(" "),
                  _vm.totalTargetInGraph
                    ? _c("BlInputSelect", {
                        staticClass: "max-w-56",
                        attrs: { input: _vm.graphTypeInput },
                        on: { changed: _vm.onChangeFilter }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.totalTargetInGraph
                    ? _c("BlInputSelect", {
                        staticClass: "max-w-72",
                        attrs: { input: _vm.progressDisplayInput },
                        on: { changed: _vm.onChangeFilter }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.graphLoading
                ? _c(
                    "div",
                    { staticClass: "grid w-full h-128 place-items-center" },
                    [_c("div", { staticClass: "blum-loader" })]
                  )
                : !_vm.totalTargetInGraph
                ? _c(
                    "div",
                    {
                      staticClass:
                        "grid w-full text-center h-128 place-items-center"
                    },
                    [
                      _vm.activeFilterDate === "Filter by date"
                        ? _c("BlTextBody1", {
                            staticClass: "text-grey-400",
                            attrs: {
                              text:
                                "The cumulative graph will be displayed once a target has been mastered."
                            }
                          })
                        : _c("BlTextBody1", {
                            staticClass: "text-center text-grey-400 px-36",
                            attrs: {
                              text:
                                "Currently, there is no data to display on the cumulative graph for the selected date, as no new targets have been mastered during this period."
                            }
                          })
                    ],
                    1
                  )
                : _c("GraphPreview", {
                    attrs: {
                      graphData: _vm.cumulativeGraph,
                      graphType: _vm.graphTypeInput.model.value,
                      progressDisplay: _vm.progressDisplayInput.model.value
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-4 px-10 pt-5 pb-10",
              attrs: { id: "detail-target" }
            },
            [
              _c("div", { staticClass: "flex items-center justify-between" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Detail of mastered targets" }
                    }),
                    _vm._v(" "),
                    _c("BlBubbleCount", {
                      attrs: { count: _vm.totalTargetInTable || 0 }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4" },
                  [
                    _c("BlInputSelect", {
                      attrs: { input: _vm.groupByInput },
                      on: { changed: _vm.onChangeSort }
                    }),
                    _vm._v(" "),
                    _vm.groupByInput.model.value === "date"
                      ? _c("BlInputSelect", {
                          attrs: { input: _vm.sortByInput },
                          on: { changed: _vm.onChangeSort }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.tableLoading
                ? _c(
                    "div",
                    { staticClass: "grid w-full h-128 place-items-center" },
                    [_c("div", { staticClass: "blum-loader" })]
                  )
                : !_vm.totalTargetInTable
                ? _c(
                    "div",
                    {
                      staticClass:
                        "grid w-full text-center h-128 place-items-center"
                    },
                    [
                      _c("BlTextBody1", {
                        staticClass: "text-grey-400",
                        attrs: {
                          text:
                            "Currently, the client doesn't have any targets yet."
                        }
                      })
                    ],
                    1
                  )
                : _c("TablePreview", {
                    attrs: { groupBy: _vm.groupByInput.model.value }
                  })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4a110ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4a110ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientCumulativeGraph.vue
// module id = null
// module chunks = 